import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import { BookingAction, SearchStatus } from '../../../../../constants';
import TwTextField from '../../../../TwTextField';
import validateEmail from '../../../../../helpers/validationHelpers/validateEmail';
import validatePhoneNumber from '../../../../../helpers/validationHelpers/validatePhoneNumber';
import withSpinner from '../../../../../HOCs/withSpinner';

const ContactAdvisorForm = ({
  saveSendTripEmailStatus, setOpenContactAdvInput, onBookClick, error,
}) => {
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleBookClick = () => {
    setSubmitted(true);
    if (validatePhoneNumber(phoneNumber)) {
      onBookClick(BookingAction.ADVICE, email, phoneNumber);
    }
  };

  const handleEmailChange = (event) => {
    setEmail(event.currentTarget.value);
  };

  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.currentTarget.value);
  };

  const emailValidated = submitted && !validateEmail(email);
  const phoneValidated = submitted && !validatePhoneNumber(phoneNumber);

  useEffect(() => {
    if (saveSendTripEmailStatus === SearchStatus.DONE && !error) {
      setEmail('');
      setPhoneNumber('');
      setSubmitted(false);
    }
  }, [error, saveSendTripEmailStatus]);

  return (
    <div className="grid grid-flow-row w-full">
      <div className="bg-theme bg-opacity-25 border border-theme text-theme text-xs px-1 mb-2 py-1 rounded relative whitespace-normal">
        Please fill out this form and one of our travel advisors will be in touch.
      </div>
      <div className="mt-1 text-theme border-theme">
        <TwTextField label="Your email" variant="outlined" className="w-full block" error={emailValidated} helperText={emailValidated && 'Valid email required.'} InputProps={{ className: 'border-theme', tabIndex: 1 }} onChange={handleEmailChange} autoFocus size="small" />
      </div>
      <div className="mt-3 text-theme border-theme">
        <TwTextField label="Phone number" variant="outlined" type="number" error={phoneValidated} helperText={phoneValidated && 'Valid phone number required.'} className="w-full block" InputProps={{ className: 'border-theme', tabIndex: 2 }} onChange={handlePhoneNumberChange} size="small" />
      </div>
      <div className="mt-2">
        {withSpinner(() => (
          <div className="text-xs text-right">
            <button type="button" className="mr-4" onClick={() => setOpenContactAdvInput(false)}>Cancel</button>
            <button type="button" className="bg-button-theme rounded-md py-2 px-4 text-button-theme font-bold" onClick={handleBookClick}>Submit</button>
            {saveSendTripEmailStatus === SearchStatus.DONE && !error
              && (
                <span className="ml-2">
                  <DoneAllIcon fontSize="small" className="text-green-500" />
                  {' '}
                  Sent!
                </span>
              )}
            {saveSendTripEmailStatus === SearchStatus.DONE && error ? <div className="text-red-600 text-sm">{error}</div> : null}
          </div>
        ), saveSendTripEmailStatus === SearchStatus.SEARCHING, undefined, undefined, 'xs')}
      </div>
    </div>
  );
};

ContactAdvisorForm.propTypes = {
  saveSendTripEmailStatus: PropTypes.number.isRequired,
  setOpenContactAdvInput: PropTypes.func.isRequired,
  onBookClick: PropTypes.func.isRequired,
  error: PropTypes.string,
};

ContactAdvisorForm.defaultProps = {
  error: undefined,
};

export default ContactAdvisorForm;
